/**
 * /dashboard/performance/reviews/$id — Review-cycle detail (Phase 7.3b).
 *
 * The single hub for a cycle: HR cycle admin (state machine + questions
 * + roster), the reviewer's "my reviews" fill form, and the calibration
 * aggregate.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/performance/reviews/[id]/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - use(params) → Route.useParams()
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { ReviewCycleDetail } from "@/components/performance/review-cycle-detail";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/reviews/$id",
)({
  component: ReviewCycleDetailRoute,
});

function ReviewCycleDetailRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { id } = Route.useParams();
  const numId = Number(id);

  return (
    <PerformanceModuleShell
      title="Review cycle"
      description="Questions, reviewer roster, the cycle state machine, your reviews and calibration."
      actions={
        <Button asChild variant="outline" className="gap-1.5">
          <Link to="/app/$tenantSlug/performance/reviews" params={{ tenantSlug }}>
            <ArrowLeft className="h-4 w-4" />
            Back to cycles
          </Link>
        </Button>
      }
    >
      <PerformanceFeatureGate>
        {Number.isFinite(numId) && numId > 0 ? (
          <ReviewCycleDetail cycleId={numId} />
        ) : (
          <p className="text-sm text-muted-foreground">
            Invalid cycle id.
          </p>
        )}
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
